<template>
  <div id="contractStatis">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'contractStatis'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/contract/ContractStatis.vue